import script from "./HrTag.vue?vue&type=script&setup=true&lang=js"
export * from "./HrTag.vue?vue&type=script&setup=true&lang=js"

import "./HrTag.vue?vue&type=style&index=0&id=eaa2cb42&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eaa2cb42"]])

export default __exports__